import { Component } from '@angular/core';
import { ApiService, ChatService, ListItem, ListResult, User } from 'angular-lib';
import { Router } from '@angular/router';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'ez-chatlist',
    template: require('./chatlist.component.html'),
    styles: [require('./chatlist.component.less')]
})
export class ChatlistComponent {
    public list: ListResult;
    public user: User;
    public hasUploadedPublicPhoto: boolean = false;
    public onlyPrivatePictures: boolean = true;

    constructor(
        private apiService: ApiService,
        private loader: LoaderService,
        private router: Router,
        private chatService: ChatService
    ) {
        this.loader.show();
        this.getList();
        this.apiService.user().subscribe((user) => {
            this.user = user;
            // check if user has public approved photo
            this.user.pictures.forEach((picture) => {
                if (
                    (
                        picture.status === 'pending' ||
                        picture.status === 'approved'
                    ) &&
                    (
                        picture.access === 'all' ||
                        picture.access === 'default'
                    )
                ) {
                    this.hasUploadedPublicPhoto = true;
                }

                if (picture.access !== 'private') {
                    this.onlyPrivatePictures = false;
                }
            });
        });

        // subscribe to new interaction of any users
        this.chatService.getGlobalOutputStream().subscribe((interaction) => {
            // if we got a new message or question
            if (
                [
                    this.chatService.GLOBAL_OUTPUT_TYPE_MESSAGE,
                    this.chatService.GLOBAL_OUTPUT_TYPE_QUESTION
                ].indexOf(interaction.type) > -1
            ) {
                this.list.items.forEach((item) => {
                    if (item.user.id === interaction.userId) {
                        item.unreadCount += 1;
                        item.updateDate(Date.now());
                    }
                })
            }

            // if we got a new match, then refresh list to display to new one
            if (interaction.type === this.chatService.GLOBAL_OUTPUT_TYPE_MATCH) {
                this.getList();
            }
        });
    }

    public chat(item: ListItem) {
        this.router.navigate(['/member/chat', item.user.id]);
    }

    public getList() {
        this.apiService.get('/ws/list/flirts')
            .subscribe(
                data => {
                    this.list = new ListResult(data);
                    this.loader.hide();
                },
                error => {
                    this.loader.hide();
                }
            );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat/chatlist.component.ts